import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';
import { createContext, useContext } from 'react';

export type DashboardContextType = {
  role: ENUM_ROLE | undefined;
  setRole: (role?: ENUM_ROLE) => void;
  isMainAdmin: boolean;
  setIsMainAdmin: (isAdmin: boolean) => void;
};

export const RoleContext = createContext({} as DashboardContextType);

const useRoleContext = () => {
  const context = useContext(RoleContext);
  return context;
};

export default useRoleContext;
